import React from 'react';
import { CONDITION_COLUMN_DEFS } from './conditionsDetailConstants';
import ConditionsInfoTooltip from './ConditionsInfoTooltip';

function colFlyout(text, label) {
  return (
    <ConditionsInfoTooltip
      ariaLabel={`${label} information`}
      className="u-els-margin-left-1o2"
      dataE2e={`conditions-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-tooltip`}
      stopClickPropagation>
      {text}
    </ConditionsInfoTooltip>
  );
}

// Builds the Leyden Table column definitions, attaching the info-icon Flyout for
// columns that declare tooltip text. Kept out of the JSX render path (AR-3.3).
const CONDITIONS_DETAIL_COLUMNS = CONDITION_COLUMN_DEFS.map((column) =>
  column.tooltip ? { ...column, headContentRight: colFlyout(column.tooltip, column.label) } : column
);

export default CONDITIONS_DETAIL_COLUMNS;
